import React, { useState } from 'react';

type Testimonial = {
  id: number;
  name: string;
  role: string;
  content: string;
};

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Leonardo Fabbri",
    role: "Bibliofilo e critico letterario",
    content: "\"Dove i libri mettono radici\" non è solo un libro, è un'esperienza che ti cambia. Le parole di Silio hanno trovato terreno fertile nella mia anima di lettore."
  },
  {
    id: 2,
    name: "Arianna Mondini",
    role: "Docente di Letteratura Comparata",
    content: "Un libro che ho consigliato a tutti i miei studenti. Silio riesce a catturare l'essenza della lettura come pochi altri autori contemporanei."
  },
  {
    id: 3,
    name: "Saverio Costantini",
    role: "Fondatore di 'Libri Nomadi'",
    content: "Nella mia esperienza trentennale come libraio, raramente ho incontrato un libro che parli così profondamente del potere trasformativo della letteratura."
  }
];

const TestimonialSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  const nextTestimonial = () => {
    setActiveIndex((current) => (current + 1) % testimonials.length);
  };
  
  const prevTestimonial = () => {
    setActiveIndex((current) => (current - 1 + testimonials.length) % testimonials.length);
  };
  
  return (
    <section className="py-5 bg-light position-relative">
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <span className="badge bg-primary bg-opacity-10 text-primary mb-3 fw-semibold">RECENSIONI</span>
            <h2 className="display-6 fw-bold mb-5">Cosa dicono i lettori</h2>
          </div>
        </div>
        
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="position-relative">
              <div className="card border-0 shadow">
                <div className="card-body p-4 p-md-5">
                  <div className="fs-1 text-primary opacity-25 mb-3">"</div>
                  
                  <p className="fs-5 mb-4">
                    {testimonials[activeIndex].content}
                  </p>
                  
                  <div className="d-flex align-items-center">
                    <div className="rounded-circle bg-primary bg-gradient text-white d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                      {testimonials[activeIndex].name.charAt(0)}
                    </div>
                    <div className="ms-3">
                      <h5 className="fw-bold mb-0">{testimonials[activeIndex].name}</h5>
                      <p className="text-muted mb-0">{testimonials[activeIndex].role}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="d-flex justify-content-between position-absolute start-0 end-0" style={{top: '50%', transform: 'translateY(-50%)'}}>
                <button 
                  className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center translate-middle-y"
                  style={{width: '40px', height: '40px'}}
                  onClick={prevTestimonial}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button 
                  className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center translate-middle-y"
                  style={{width: '40px', height: '40px'}}
                  onClick={nextTestimonial}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
            
            <div className="d-flex justify-content-center mt-4">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIndex(idx)}
                  className={`btn ${activeIndex === idx ? 'btn-primary' : 'btn-light'} btn-sm rounded-circle mx-1`}
                  style={{width: '10px', height: '10px', padding: 0}}
                  aria-label={`Testimonianza ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
        
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
              <a href="#il-libro" className="btn btn-primary px-4">
                Scopri il libro
              </a>
              <a href="https://bookolica.gumroad.com/l/doveilibrimettonoradici" className="btn btn-outline-primary px-4">
                Acquista ora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection; 